import React, { useState, useEffect } from "react";
import { Text } from "react-internationalization";
import moment from "moment";
import { connect, useSelector } from "react-redux";
import AssignPCP from "../../../AssignPCP";
import Popup from "reactjs-popup";
import {
  setStateParams,
  getPcpList,
} from "../../../../Redux/Actions/webAppActions";
import Button from "../../../../Utils/GenericUI/Button";
import PcpInputs from "../PcpInputs";
// import {  } from "react";
// import { useEffect } from "react";

const Step2 = (props) => {
  const [state, setState] = useState({
    stateFlag: false,
    pcpShown: props.pcpSelected.pcpName ? props.pcpSelected.pcpName : "",
    clinicShown:
      props.pcpSelected.pcpName && props.pcpSelected.pcpName !== "---Select---"
        ? props.physiciansData.length > 1
          ? props.physiciansData.filter(
              (data1) => data1.doctorName === props.pcpSelected.pcpName
            )[0] != undefined
            ? props.physiciansData.filter(
                (data1) => data1.doctorName === props.pcpSelected.pcpName
              )[0].clinicName
            : ""
          : ""
        : props.preEnrollInfo && props.preEnrollInfo.pcpDetails
        ? props.preEnrollInfo.pcpDetails.name
        : "",
  });
  const clickedSaveNextIds = useSelector(
    (state1) => state1.webApp.clickedSaveNextIds
  );
  useEffect(() => {
    const {
      // data,
      permanentAddrStreet,
      permanentCity,
      permanentZip,
    } = props;
    let fullAddr = data.permanentAddrStreet ? data.permanentAddrStreet : "";
    let zip = data.permanentZip;
    if (props.product != "PDP" && props.productName !== "Medicare Supplement") {
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        zip !== "" &&
        props.deeplink === false
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          zip !== permanentZip
        ) {
          props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: zip,
            distance: "100",
            customerId: props?.customerId,
            planYear: props.year,
            productId:
              props.pendingApplFlag === false
                ? props.productId
                : props.preEnrollInfo.productId,
          });
          props.setStateParams("permanentAddrStreet", data.permanentAddrStreet);
          props.setStateParams("permanentCity", data.permanentCity);
          props.setStateParams("permanentZip", zip);
          // setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        props.dpzipCode !== "" &&
        props.deeplink === true
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          props.dpzipCode !== permanentZip
        ) {
          props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: props.dpzipCode,
            distance: "100",
            customerId: props?.customerId,
            planYear: props.year,
            productId:
              props.pendingApplFlag === false
                ? props.productId
                : props.preEnrollInfo.productId,
          });
          props.setStateParams("permanentAddrStreet", data.permanentAddrStreet);
          props.setStateParams("permanentCity", data.permanentCity);
          props.setStateParams("permanentZip", props.dpzipCode);
          // this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      // else {
      if (
        fullAddr === "" ||
        fullAddr === undefined ||
        data.permanentCity === ""
      ) {
        //   if(data.permanentAddrStreet === "" ||
        // data.permanentCity === ""){
        setState({ ...state, flag: true });
        props.setSnackBar(
          props.lang === "es"
            ? "Complete la dirección permanente en la sección 1 para obtener el PCP y el nombre de la clínica."
            : "Please fill permanent address in section 1 to get PCP's and Clinic Name."
        );
      }
    }
    if (props.preEnrollInfo.pcpName) {
      setState({
        ...state,
        pcpShown: props.preEnrollInfo.pcpName,
        clinicShown: props.preEnrollInfo.pcpDetails.name
          ? props.preEnrollInfo.pcpDetails.name
          : "",
      });
    }
  }, []);
  useEffect(() => {
    const clinicName =
      props.pcpSelected.pcpName && props.pcpSelected.pcpName !== "---Select---"
        ? props.physiciansData.length > 1
          ? props.physiciansData.filter(
              (data1) => data1.doctorName === props.pcpSelected.pcpName
            )[0] != undefined
            ? props.physiciansData.filter(
                (data1) => data1.doctorName === props.pcpSelected.pcpName
              )[0].clinicName
            : ""
          : ""
        : props.preEnrollInfo && props.preEnrollInfo.pcpDetails
        ? props.preEnrollInfo.pcpDetails.name
        : "";

    if (props.pcpSelected.pcpName !== state.pcpShown) {
      setState({
        ...state,
        pcpShown: props.pcpSelected.pcpName,
        clinicShown: clinicName,
      });
    }
  }, [props]);
  const { data } = props;
  return (
    <React.Fragment>
      {/* <div class="tab-content tab-contentSharp"> */}
      <div
        id="step2"
        class={
          props.preEnrollInfo?.appStatus != "READY" &&
          props.preEnrollInfo?.appStatus != "SUBMITTED"
            ? "container tab-pane active"
            : "container tab-pane active disable-form"
        }
      >
        <h3 class="tab-heading">
          <Text id="st2cat3.STEP2" />: <Text id="step2.MEDICAREINFO" />
        </h3>
        <p class="medicare-note">
          <Text id="step2.PleasePara" />:
          <br />
          <strong>
            <Text id="step2.Note" />:{" "}
          </strong>{" "}
          <Text id="step2.notePart" />.
        </p>

        <h4 class="sub-heading">
          <strong>
            <Text id="step2.APara" />.
          </strong>
        </h4>
        <div class="form-group row">
          <div class="col-md-6">
            <p>
              <label for="medicareNumber" class="control-label">
                <Text id="step2.MedicareNumber" />*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                placeholder="XXXXXXXXXXX"
                //pattern="/[a-zA-Z0-9]{10,11}/"
                name="medicareNumber"
                id="medicareNumber"
                minLength="11"
                maxLength="11"
                class={
                  clickedSaveNextIds.includes("next2") &&
                  data.medicareNumber.length < 11
                    ? "error-input"
                    : "form-control"
                }
                value={data.medicareNumber}
                onChange={props.handleChange}
                required=""
              />
            </p>
            {props.agentLogin === true && (
              <Button
                className="btn btn-secondary-enroll mt-2 mb-1"
                id="checkEligibity"
                onButtonClick={props.checkEligibility}
                buttonLabel={"Check Eligibility"}
              />
            )}
            <p>
              <label class="control-label" for="partAEffDate">
                <Text id="step2.Hospi" />*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                placeholder="MM/DD/YYYY "
                maxLength="10"
                class={
                  clickedSaveNextIds.includes("next2") &&
                  (data.partAEffDate === "" ||
                    !moment(data.partAEffDate, "MM/DD/YYYY", true).isValid())
                    ? "error-input"
                    : "form-control"
                }
                onClick={(e) => props.handleDates("partAEffDate")}
                name="partAEffDate"
                id="partAEffDate"
                value={data.partAEffDate}
                onChange={props.handleDate}
                required=""
              />
            </p>

            <p>
              <label class="control-label" for="partBEffDate">
                <Text id="step2.Medical" />*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                placeholder="MM/DD/YYYY"
                maxLength="10"
                class={
                  clickedSaveNextIds.includes("next2") &&
                  (data.partBEffDate === "" ||
                    !moment(data.partBEffDate, "MM/DD/YYYY", true).isValid())
                    ? "error-input"
                    : "form-control"
                }
                onClick={(e) => props.handleDates("partBEffDate")}
                name="partBEffDate"
                id="partBEffDate"
                value={data.partBEffDate}
                onChange={props.handleDate}
                required=""
              />
            </p>
          </div>
          <div class="col-md-6">
            <img
              src={require("../../../../assests/images/Medicardlogoshp_New.png")}
              alt=""
              class="width100per"
            />
          </div>
        </div>

        <h4 class="sub-heading">
          <strong>
            <Text id="step2.BPara" />
          </strong>
        </h4>
        <div class="form-group">
          {/*<p class="text-align-justify">
              <strong>
                <Text id="step2.BPara"/>.{" "}
                {/*You can also
                choose to pay your premium by automatic deduction from your
                Social Security or Railroad Retirement Board (RRB) benefit check
                each month.}
              </strong>
            </p>*/}

          <p class="text-align-justify">
            <strong>
              <Text id="step2.Para8" />.
              {/* You can also choose to pay your premium by automatic deduction
                from your Social Security or RRB.*/}
            </strong>
          </p>
          <p class="text-align-justify">
            <strong>
              <Text id="step2.Para4" />.
            </strong>
          </p>

          <p class="text-align-justify">
            <strong>
              <Text id="step2.Para9" />.
            </strong>
          </p>

          <p class="medicare-note text-align-justify">
            <Text id="step2.Para10" />.
            <br />
            <br />
            <Text id="step2.Para11" />.
          </p>

          <p>
            <strong>
              <Text id="step2.premiumType" />:
            </strong>
          </p>

          <div class="radio radio-tab">
            <div class="custom-control custom-radio mt-3">
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="radio"
                name="premiumType"
                id="getABill"
                class="custom-control-input"
                value="D"
                checked={data.premiumType === "D"}
                onChange={props.handleChange}
              />
              <label for="getABill" class="radio-inline custom-control-label">
                <strong>
                  <Text id="step2.Getbill" />
                </strong>
              </label>
            </div>

            <div class="custom-control custom-radio mt-3">
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="radio"
                name="premiumType"
                class="custom-control-input"
                id="electronicFunds"
                value="R"
                checked={data.premiumType === "R"}
                onChange={props.handleChange}
              />
              <label
                for="electronicFunds"
                class="radio-inline custom-control-label"
              >
                <strong>
                  <Text id="step2.Electronicfunds" />.
                </strong>
              </label>
            </div>

            <div class="form-group row ml-3 mt-3">
              <div class="col-md-6">
                <p>
                  <label for="acctholdername" class="control-label">
                    <Text id="step2.Accountname" />:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    maxLength="40"
                    type="text"
                    class="form-control"
                    id="acctholdername"
                    name="acctholdername"
                    value={data.acctholdername}
                    onChange={props.handleChange}
                  />
                </p>

                <fieldset class="radio radio-tab">
                  <legend class="control-label">
                    {" "}
                    <Text id="step2.Accounttype" />:
                  </legend>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="acctType"
                      id="checking"
                      value="C"
                      class="custom-control-input"
                      checked={data.acctType === "C"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="checking"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Checking" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="acctType"
                      id="saving"
                      value="S"
                      class="custom-control-input"
                      checked={data.acctType === "S"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="saving"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Saving" />
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-6">
                <p>
                  <label for="bankname" class="control-label">
                    <Text id="step2.Bankname" />:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    maxLength="20"
                    type="text"
                    class="form-control"
                    id="bankname"
                    name="bankname"
                    value={data.bankname}
                    onChange={props.handleChange}
                  />
                </p>

                <p>
                  <label for="routingNumber" class="control-label">
                    <Text id="step2.routingnumber" />:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control"
                    id="routingNumber"
                    name="routingNumber"
                    value={data.routingNumber}
                    onChange={props.handleNumberChange}
                    placeholder="Enter 9-digit routing number"
                    maxLength="9"
                  />
                </p>

                <p>
                  <label for="accountNumber" class="control-label">
                    <Text id="step2.Bankaccountnumber" />:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    pattern="[0-9]*"
                    class="form-control"
                    id="accountNumber"
                    name="accountNumber"
                    value={data.accountNumber}
                    onChange={props.handleNumberChange}
                    placeholder="Enter a numeric a/c number"
                    maxLength="17"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>

        <h4 class="sub-heading">
          <strong>
            {" "}
            <Text id="step2.C" />
          </strong>
        </h4>
        <div class="form-group">
          <ol>
            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                style={{ display: "contents" }}
              >
                <legend /*style={{ marginTop: "-2.5rem" }}*/>
                  <Text id="step2.q1" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="retiree"
                    id="retireeY"
                    class="custom-control-input"
                    value="Y"
                    checked={data.retiree === "Y"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="retireeY"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="retiree"
                    id="retireeNo"
                    class="custom-control-input"
                    value="N"
                    checked={data.retiree === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="retireeNo"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                <div class="row" style={{ marginBottom: "3.5rem" }}>
                  <div class="col-4">
                    {data.retiree === "Y" ? (
                      <React.Fragment>
                        <label for="retiredate">
                          <Text id="st2cat3.retirement" />:
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          name="retiredate"
                          id="retiredate"
                          placeholder="MM/DD/YYYY"
                          class="form-control"
                          maxLength="10"
                          value={data.retiredate}
                          onChange={props.handleDate}
                          onClick={(e) => props.handleDates("retiredate")}
                        />
                      </React.Fragment>
                    ) : null}
                  </div>
                  <div class="col-2"></div>
                  <div class="col-4">
                    {data.retiree === "N" ? (
                      <>
                        <label for="retirename">
                          <Text id="st2cat3.nameretiree" />:
                        </label>{" "}
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          name="retirename"
                          class="form-control"
                          value={data.retirename}
                          maxLength="40"
                          onChange={props.handleChange}
                        />
                      </>
                    ) : null}
                  </div>
                </div>
              </fieldset>
            </li>
            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                style={{ display: "contents" }}
              >
                <legend style={{ marginTop: "-3.5rem" }}>
                  <Text id="step2.q2" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="empCover"
                    id="empCoverY"
                    class="custom-control-input"
                    value="Y"
                    checked={data.empCover === "Y"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="empCoverY"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="empCover"
                    id="empCoverno"
                    class="custom-control-input"
                    value="N"
                    checked={data.empCover === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="empCoverno"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.empCover === "Y" ? (
                  <div class="row">
                    <div class="col-4">
                      <label for="retiredate">
                        <Text id="st2cat3.spousename" />:
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dependentSpouse"
                        id="dependentSpouse"
                        class="form-control"
                        value={data.dependentSpouse}
                        maxLength="40"
                        onChange={props.handleChange}
                      />
                    </div>
                    <div class="col-2"></div>
                    <div class="col-4">
                      <label for="retirename">
                        <Text id="st2cat3.dependents" />:
                      </label>{" "}
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        name="dependentOther"
                        class="form-control"
                        value={data.dependentOther}
                        onChange={props.handleChange}
                        maxLength="40"
                      />
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>

            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                style={{ display: "contents" }}
              >
                <legend /*style={{ marginTop: "-2.5rem" }}*/>
                  <Text id="step2.q3" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isSpouseWork"
                    id="c_q5_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.isSpouseWork === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q5_Y" class="radio-inline custom-control-label">
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isSpouseWork"
                    id="c_q5_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.isSpouseWork === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q5_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>
              </fieldset>
            </li>

            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                style={{ display: "contents" }}
              >
                {/* <div class="row">
                    <div class="col-md-6">
                      <fieldset class="radio radio-tab mt-3"> */}
                <legend>
                  <Text id="step2.q7Part" />
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isCurrentPatient"
                    id="currentPatient_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.isCurrentPatient === "Y"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="currentPatient_Y"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isCurrentPatient"
                    id="currentPatient_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.isCurrentPatient === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="currentPatient_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                  {/* </div>
                      </fieldset>
                    </div> */}
                </div>
              </fieldset>
            </li>
            <li>
              <fieldset
                class="radio radio-tab mt-3"
                style={{ display: "contents" }}
              >
                <legend>
                  <Text id="step2.q4" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="esrdInd"
                    id="c_q1_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.esrdInd === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q1_Y" class="radio-inline custom-control-label">
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="esrdInd"
                    id="c_q1_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.esrdInd === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q1_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>
                {data.esrdInd === "Y" ? (
                  <div>
                    <legend>
                      <Text id="st2cat3.q4sub1" />*
                    </legend>
                    <Text id="st2cat3.q4sub2" />.<br></br>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="esrdcontact"
                        id="esrdcontact_Y"
                        class="custom-control-input"
                        value="Y"
                        checked={data.esrdcontact === "Y"}
                        onChange={props.handleChange}
                      />
                      <label
                        for="esrdcontact_Y"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="esrdcontact"
                        id="esrdcontact_no"
                        class="custom-control-input"
                        value="N"
                        checked={data.esrdcontact === "N"}
                        onChange={props.handleChange}
                      />
                      <label
                        for="esrdcontact_no"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>
            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                id="c_qns2"
                style={{ display: "contents" }}
              >
                <legend /*style={{ marginTop: "-2.5rem" }}*/>
                  <Text id="step2.q5" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isDrugCoverage"
                    id="c_q2_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.isDrugCoverage === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q2_Y" class="radio-inline custom-control-label">
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isDrugCoverage"
                    id="c_q2_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.isDrugCoverage === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q2_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.isDrugCoverage === "Y" ? (
                  <div id="c_q2_fields">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <label for="nameOfCoverage" class="control-label">
                          <Text id="st2cat3.coverage" />*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.nameOfCoverage === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="nameOfCoverage"
                          name="nameOfCoverage"
                          maxLength="30"
                          value={data.nameOfCoverage}
                          onChange={props.handleChange}
                        />
                      </div>
                      <div class="col-md-4">
                        <label for="covMemberNumber" class="control-label">
                          <Text id="st2cat3.coverageId" />*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.covMemberNumber === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="covMemberNumber"
                          name="covMemberNumber"
                          value={data.covMemberNumber}
                          onChange={props.handleChange}
                          maxLength="20"
                        />
                      </div>
                      <div class="col-md-4">
                        <label for="covGroupNumber" class="control-label">
                          <Text id="st2cat3.grpcov" />*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.covGroupNumber === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="covGroupNumber"
                          name="covGroupNumber"
                          value={data.covGroupNumber}
                          onChange={props.handleChange}
                          maxLength="30"
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>

            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                id="c_qns4"
                style={{ display: "contents" }}
              >
                <legend /*style={{ marginTop: "-2.5rem" }}*/>
                  <Text id="step2.q6" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="ltcInd"
                    id="c_q4_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.ltcInd === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q4_Y" class="radio-inline custom-control-label">
                    <Text id="app.Yes" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="ltcInd"
                    id="c_q4_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.ltcInd === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q4_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.ltcInd === "Y" ? (
                  <div id="c_q4_fields">
                    <div class="row mt-3">
                      <div class="col-md-7">
                        <label for="nameOfInstitution" class="control-label">
                          <Text id="st2cat3.isnt" />
                          *:
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.nameOfInstitution === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="nameOfInstitution"
                          name="nameOfInstitution"
                          value={data.nameOfInstitution}
                          onChange={props.handleChange}
                          required=""
                          maxLength="50"
                        />
                      </div>
                      {/* <div class="col-md-5">
                          <label for="addrOfInstitution" class="control-label">
                            <Text id="st2cat3.phoneinst" />
                            *:
                          </label>
                          <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                            type="text"
                            class={
                              data.addrOfInstitution === ""
                                ? "error-input"
                                : "form-control"
                            }
                            id="addrOfInstitution"
                            name="addrOfInstitution"
                            value={data.addrOfInstitution}
                            onChange={props.handleChange}
                            placeholder="(   )   -"
                            maxlength="14"
                          />
                        </div> */}
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-12">
                        <label for="addrOfInstitution" class="control-label">
                          <Text id="st2cat3.adressint" />
                          *:
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          maxLength="50"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.addrOfInstitution === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="addrOfInstitution"
                          name="addrOfInstitution"
                          value={data.addrOfInstitution}
                          onChange={props.handleChange}
                          required=""
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>

            <li>
              <fieldset
                class="radio radio-tab ml-3 mt-3"
                style={{ display: "contents" }}
              >
                {/* {navigator.userAgent.indexOf("MSIE") > -1 ||
                  navigator.userAgent.indexOf("rv:") > -1 ? ( */}
                <legend /*style={{ marginTop: "-40px" }}*/>
                  <Text id="step2.q7" />
                </legend>
                {/* ) : (
                    <legend>
                      <Text id="step2.q7" />
                    </legend>
                  )} */}
                <PcpInputs
                  handleChange={props.handleChange}
                  data={props.data}
                />
              </fieldset>
            </li>
            <li
              class={
                navigator.userAgent.indexOf("MSIE") > -1 ||
                navigator.userAgent.indexOf("rv:") > -1
                  ? "margintest"
                  : ""
              }
              style={{ marginTop: "3rem" }}
            >
              <div class="form-group">
                <div style={{ display: "inline-flex" }}>
                  <label for="language" class="control-label mr-2">
                    <Text id="step2.A1" />.
                  </label>
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                    // style={{ marginTop: "1rem" }}
                  >
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="checkbox"
                      name="prefLng"
                      id="lfp_spanish"
                      class="custom-control-input"
                      value="SPA"
                      checked={data.prefLng === "SPA"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_spanish"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Spanish" />
                    </label>
                  </div>
                </div>
                <fieldset class="radio radio-tab mt-3">
                  <legend>
                    <Text id="step2.A2" />.
                  </legend>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_braille"
                      class="custom-control-input"
                      value="B"
                      checked={data.accessibleFormatVal === "B"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_braille"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar1" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_largeprint"
                      class="custom-control-input"
                      value="L"
                      checked={data.accessibleFormatVal === "L"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_largeprint"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar2" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline mt-1">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_other"
                      class="custom-control-input"
                      value="OTHER"
                      checked={
                        data.accessibleFormatVal === "OTHER"
                        // ["",undefined].every((e1)=>e1!==document.getElementById("otherlanguageValue")?.value)
                      }
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_other"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar3" />
                    </label>
                  </div>
                  <div
                    class="custom-control custom-control-inline mt-1"
                    // style={{ width: "500px" }}
                  >
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="otherlanguageValue"
                      name="accessibleFormatOth"
                      value={data.accessibleFormatOth}
                      disabled={
                        data.accessibleFormatVal === "" ||
                        data.accessibleFormatVal === "B" ||
                        data.accessibleFormatVal === "L"
                      }
                      onChange={props.handleChange}
                      class={"form-control"}
                      maxLength="10"
                    />
                  </div>
                </fieldset>
                <br />
              </div>
            </li>

            {/* <li
                class={
                  navigator.userAgent.indexOf("MSIE") > -1 ||
                  navigator.userAgent.indexOf("rv:") > -1
                    ? "margintest"
                    : ""
                }
                style={{ marginTop: "3rem" }}
              >
                <fieldset
                  class="radio radio-tab ml-3 mt-3"
                  style={{ display: "contents" }}
                >
                  <div class="form-group marginStep2">
                    <fieldset
                      class="radio radio-tab mt-3"
                      style={{ display: "contents" }}
                    >
                      
                      <legend>
                        <Text id="step2.q8" />
                      </legend>
                     

                      <div class="row">
                        <div class="col-md-12">
                          <React.Fragment>
                            <div class="custom-control custom-radio custom-control-inline mt-3">
                              <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                                type="radio"
                                name="spanish"
                                id="lfp_spanish"
                                class="custom-control-input"
                                value="SPANISH"
                                checked={data.spanish === "SPANISH"}
                                onChange={props.handleChange}
                              />
                              <label
                                for="lfp_spanish"
                                class="radio-inline custom-control-label"
                              >
                                <Text id="step2.q8rod1" />
                              </label>
                            </div>
                            <br />
                            <div class="custom-control custom-radio custom-control-inline mt-3">
                              <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                                type="radio"
                                name="accessibleFormatVal"
                                id="lfp_braille"
                                class="custom-control-input"
                                value="BRAILLE"
                                checked={data.accessibleFormatVal === "BRAILLE"}
                                onChange={props.handleChange}
                              />
                              <label
                                for="lfp_braille"
                                class="radio-inline custom-control-label"
                              >
                                <Text id="step2.q8rod2" />
                              </label>
                            </div>
                            <br />
                            <div class="custom-control custom-radio custom-control-inline mt-3">
                              <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                                type="radio"
                                name="accessibleFormatVal"
                                id="lfp_largeprint"
                                class="custom-control-input"
                                value="LARGEPRINT"
                                checked={
                                  data.accessibleFormatVal === "LARGEPRINT"
                                }
                                onChange={props.handleChange}
                              />
                              <label
                                for="lfp_largeprint"
                                class="radio-inline custom-control-label"
                              >
                                <Text id="step2.q8rod3" />
                              </label>
                            </div>
                            <br />
                            <div class="custom-control custom-radio custom-control-inline mt-3">
                              <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                                type="radio"
                                name="accessibleFormatVal"
                                id="lfp_other"
                                class="custom-control-input"
                                value="OTHER"
                                checked={data.accessibleFormatVal === "OTHER"}
                                onChange={props.handleChange}
                              />
                              <label
                                for="lfp_other"
                                class="radio-inline custom-control-label"
                              >
                                <Text id="step2.q8rod4" />
                              </label>
                            </div>
                            <br />
                          </React.Fragment>

                          <label
                            for="lfp_other_field"
                            class="custom-control-inline mt-1"
                          >
                            <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                              type="text"
                              placeholder={
                                data.accessibleFormatVal === "OTHER"
                                  ? "Please enter Other Language"
                                  : ""
                              }
                              name="accessibleFormatVal"
                              id="lfp_other_field"
                              maxlength="11"
                              class="form-control"
                              required=""
                              value={
                                data.accessibleFormatVal === "BRAILLE" ||
                                data.accessibleFormatVal === "LARGEPRINT" ||
                                data.accessibleFormatVal === "OTHER"
                                  ? ""
                                  : data.accessibleFormatVal
                              }
                              onChange={props.handleChange}
                              disabled={
                                data.accessibleFormatVal === "" ||
                                data.accessibleFormatVal === "BRAILLE" ||
                                data.accessibleFormatVal === "LARGEPRINT"
                              }
                            />
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </fieldset>
              </li> */}

            {/* {props.year === "2023" || props.year === "2024" ?  */}
            {/* ( */}
              <>
                <li>
                  {" "}
                  <div class="form-group">
                    <label class="control-label">
                      <Text id="step2.Quest23" />.
                    </label>
                    <div class="row">
                      <div class="col-sm">
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="ETHNICITY"
                            value="NA"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "NA" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label>
                            <Text id="step2.quesOP1" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            value="PR"
                            name="ETHNICITY"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "PR" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label>
                            <Text id="step2.quesOP2" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            value="OTH"
                            name="ETHNICITY"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "OTH" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label>
                            <Text id="step2.quesOP3" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            value="NR"
                            name="ETHNICITY"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "NR" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label>
                            <Text id="step2.quesOP4" />
                          </label>
                        </div>
                      </div>
                      <div class="col-sm">
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            id="MX"
                            value="MX"
                            name="ETHNICITY"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "MX" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label class="">
                            <Text id="step2.quesOP5" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            id="CUB"
                            name="ETHNICITY"
                            value="CUB"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "CUB" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label class="">
                            <Text id="step2.quesOP6" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="form-group">
                    <label class="control-label">
                      <Text id="step2.ques24" />.
                    </label>
                    <div class="row">
                      <div class="col-sm" style={{ display: "grid" }}>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="300"
                            class="customCheckbox"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "300" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                          />
                          <label>
                            <Text id="step2.American" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="431"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "431" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Japanese" />
                          </label>
                        </div>

                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="451"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "451" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Vietnam" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="201"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "201" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Black" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="441"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "441" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Korean" />
                          </label>
                        </div>
                      </div>
                      <div class="col-sm" style={{ display: "grid" }}>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="499"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "499" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.OtherAsian" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="411"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "411" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label for="language">
                            <Text id="step2.Chinese" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="501"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "501" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.NativeHawaiian" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="599"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "599" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.OtherPaci" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="421"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "421" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Filipino" />
                          </label>
                        </div>
                      </div>
                      <div class="col-sm">
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="511"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "511" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Samoan" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="101"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "101" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.White" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="521"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "521" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.Guamanian" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="401"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "401" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.southAsian" />
                          </label>
                        </div>
                        <div>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="checkbox"
                            name="RACE"
                            value="999"
                            checked={data.ethnicityRace.some((item) =>
                              item.piValue === "999" ? true : false
                            )}
                            onChange={props.handleStepCheckbox}
                            class="customCheckbox"
                          />
                          <label>
                            <Text id="step2.notAns" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </li>
              </>
            {/* ) : null} */}
          </ol>
        </div>
        <div class="mt-3">
          <label class="control-label" for="fileUpload">
            <Text id="step4Agent.fileUpload" />
          </label>
          <div class="card">
            <div className="card-header file-upload-container-aligner display-inline-flex">
              <div class="select-file-typeSetp">
                <label
                  class="control-label select-filetype-label-setp"
                  for="fileType"
                >
                  Select File Type
                </label>
                <select
                  name="fileType"
                  id="fileType"
                  class={"form-control"}
                  value={props.fileType}
                  onChange={props.handleChange}
                >
                  {props.typeOfFilesToUpload.map((item, i) => {
                    return (
                      <option class="select-option" value={item.value} key={i}>
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="file-upload-aligner file-upload-container">
                <label
                  className={
                    props.fileType === ""
                      ? "btn btn-secondary"
                      : "btn btn-primary"
                  }
                >
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="file"
                    name="fileUpload"
                    id="fileUpload"
                    class="display-none"
                    onChange={props.handleChange}
                    onClick={(event) => (event.target.value = "")}
                    disabled={props.fileType === "" ? true : false}
                  />
                  <i className="fa fa-upload" aria-hidden="true"></i>&nbsp;
                  <Text id="step4Agent.uploadFile" />
                </label>
              </div>
              {/* <div>
                    <button
                      className="btn btn-danger"
                      onClick={props.clearFiles}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i>&nbsp;
                      <Text id="step4Agent.cancel" />
                    </button>
                  </div> */}
            </div>
            <div class="panel">
              <div class="card-body">
                {props.selectedFiles.map(
                  (file, index) =>
                    file.attachmentType !== "SIGNATURE" &&
                    file.attachmentType !== "ENROLLMENT" &&
                    file.attachmentType !== "SOA" && (
                      <div class="row">
                        <p class="col-md-3">
                          {file?.name || file?.attachmentType}
                        </p>
                        <a
                          href={props.url}
                          target="_blank"
                          class="col-md-5"
                          onClick={() =>
                            props.viewFile(
                              index,
                              file.name || file.attachmentName
                            )
                          }
                        >
                          {file?.File?.name || file?.attachmentName}
                        </a>
                        <p class="col-md-2">
                          {file && file.File
                            ? `${file.File.size / 1024} kb`
                            : ""}{" "}
                        </p>
                        <a
                          class="col-md-2 cursor-pointer"
                          onClick={() =>
                            props.removeFile(
                              index,
                              file.name || file.attachmentName
                            )
                          }
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                        </a>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <h4 class="sub-heading">
            <strong>E. Language and Format Preferences</strong>
          </h4>
          <div class="form-group">
            <fieldset class="radio radio-tab mt-3">
              <legend>
                Please check one of the boxes below if you would prefer us to
                send you information in a language other than English or in
                another format
              </legend>
            </fieldset>
          </div>*/}
        <br />
        {props.year === "2023" || props.year === "2024" ? (
          <p>
            <Text id="step2.Para22" />.
          </p>
        ) : (
          <p>
            <Text id="step2.Para12" />.
          </p>
        )}

        <p>
          <Text id="step2.Para13" /> &nbsp;
          <a
            href="https://sharpmedicareadvantage.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b>
              <Text id="step2.sharplink" />
            </b>
          </a>
          . <Text id="step2.Para14" />.
        </p>
        <p>
          <strong>
            <Text id="step2.NOTECAp" />:
          </strong>{" "}
          <Text id="step2.NOTECApPart" />.
        </p>
        {props.preEnrollInfo?.appStatus != "READY" &&
          props.preEnrollInfo?.appStatus != "SUBMITTED" && (
            <button
              class="btn btn-saveNext"
              id="next2"
              onClick={props.redirect}
            >
              <Text id="app.Save_Next" />
            </button>
          )}
      </div>
      {/* </div> */}
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    physiciansData: state.webApp.physiciansData,
    pcpSelected: state.webApp.selectedVo,
    preEnrollInfo: state.webApp.preEnrollInfo,
    stateId: state.webApp.stateId,
    planType: state.webApp.planType,
    product: state.webApp.product,
    deeplink: state.login.deeplink,
    customerId: state.login.customerId,
    agentLogin: state.login.agentLoggedIn,
    lang: state.webApp.language,
    productId: state.login.productId,
    pendingApplFlag: state.webApp.pendingApplFlag,
  };
};
const mapDispatchToProps = {
  getPcpList,
  setStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(Step2);
